import styled from '@emotion/styled';

import { breakpoints } from '@coursera/cds-core';

/** A card UI element that involves a white background with grey borders and rounded corners */
export const Card = styled.div`
  padding: ${({ theme }) => 'var(--cds-spacing-400)'};
  border-radius: ${({ theme }) => 'var(--cds-spacing-100)'};
  border: 2px solid ${({ theme }) => 'var(--cds-color-grey-50)'};
  background-color: ${({ theme }) => 'var(--cds-color-neutral-background-primary)'};
  margin-bottom: ${({ theme }) => 'var(--cds-spacing-400)'};

  ${({ theme }) => breakpoints.down('xs')} {
    max-width: 100%;
    padding: ${({ theme }) => 'var(--cds-spacing-300)'};
    border-left: none;
    border-right: none;
    border-radius: 0;
  }
`;
